/**
 * Complete list of amenities for B&B I Maestri.
 * Each category has an icon (Font Awesome 6) and a list of services in IT/EN/FR.
 */

export const AMENITIES = [
  {
    id: "bathroom",
    icon: "fa-bath",
    title: { it: "Bagno", en: "Bathroom", fr: "Salle de bain" },
    items: {
      it: ["Bagno privato", "WC", "Doccia / Vasca", "Asciugacapelli", "Accappatoio", "Prodotti da bagno in omaggio", "Asciugamani", "Carta igienica"],
      en: ["Private bathroom", "Toilet", "Shower / Bathtub", "Hairdryer", "Bathrobe", "Free toiletries", "Towels", "Toilet paper"],
      fr: ["Salle de bain privée", "WC", "Douche / Baignoire", "Sèche-cheveux", "Peignoir", "Produits de toilette gratuits", "Serviettes", "Papier toilette"]
    }
  },
  {
    id: "bedroom",
    icon: "fa-bed",
    title: { it: "Camera", en: "Bedroom", fr: "Chambre" },
    items: {
      it: ["Biancheria da letto", "Armadio o guardaroba", "Stand appendiabiti", "Camera anallergica", "Camera insonorizzata", "Presa elettrica vicino al letto"],
      en: ["Bed linen", "Wardrobe / closet", "Clothes rack", "Hypoallergenic room", "Soundproof room", "Socket near the bed"],
      fr: ["Linge de lit", "Armoire / penderie", "Portant à vêtements", "Chambre hypoallergénique", "Chambre insonorisée", "Prise près du lit"]
    }
  },
  {
    id: "kitchen",
    icon: "fa-utensils",
    title: { it: "Cucina", en: "Kitchen", fr: "Cuisine" },
    items: {
      it: ["Angolo cottura", "Frigorifero", "Forno a microonde", "Lavastoviglie", "Macchina da caffè", "Bollitore elettrico", "Tostapane", "Utensili da cucina", "Tavolo da pranzo"],
      en: ["Kitchenette", "Refrigerator", "Microwave", "Dishwasher", "Coffee machine", "Electric kettle", "Toaster", "Kitchenware", "Dining table"],
      fr: ["Coin cuisine", "Réfrigérateur", "Micro-ondes", "Lave-vaisselle", "Machine à café", "Bouilloire électrique", "Grille-pain", "Ustensiles de cuisine", "Table à manger"]
    }
  },
  {
    id: "media",
    icon: "fa-tv",
    title: { it: "Media & tecnologia", en: "Media & tech", fr: "Médias & techno" },
    items: {
      it: ["TV a schermo piatto", "Servizio streaming (Netflix)", "Canali via cavo / pay-per-view", "Radio", "WiFi gratuito in tutta la struttura"],
      en: ["Flat-screen TV", "Streaming service (Netflix)", "Cable / pay-per-view channels", "Radio", "Free WiFi throughout the property"],
      fr: ["TV à écran plat", "Service de streaming (Netflix)", "Chaînes câblées / payantes", "Radio", "WiFi gratuit dans tout l'établissement"]
    }
  },
  {
    id: "comfort",
    icon: "fa-fan",
    title: { it: "Comfort", en: "Comfort", fr: "Confort" },
    items: {
      it: ["Aria condizionata", "Riscaldamento", "Ventilatore", "Insonorizzazione", "Ferro e asse da stiro", "Struttura interamente non fumatori"],
      en: ["Air conditioning", "Heating", "Fan", "Soundproofing", "Iron and ironing board", "Entirely non-smoking property"],
      fr: ["Climatisation", "Chauffage", "Ventilateur", "Insonorisation", "Fer et planche à repasser", "Établissement entièrement non-fumeurs"]
    }
  },
  {
    id: "reception",
    icon: "fa-concierge-bell",
    title: { it: "Accoglienza", en: "Reception", fr: "Accueil" },
    items: {
      it: ["Check-in e check-out privati", "Deposito bagagli (a pagamento)", "Armadietti", "Fattura disponibile su richiesta", "Camere familiari"],
      en: ["Private check-in & check-out", "Luggage storage (charges apply)", "Lockers", "Invoice on request", "Family rooms"],
      fr: ["Check-in et check-out privés", "Consigne à bagages (payant)", "Casiers", "Facture sur demande", "Chambres familiales"]
    }
  },
  {
    id: "cleaning",
    icon: "fa-broom",
    title: { it: "Pulizia & lavanderia", en: "Cleaning & laundry", fr: "Nettoyage & blanchisserie" },
    items: {
      it: ["Pulizie giornaliere", "Servizio lavanderia (a pagamento)", "Servizio stireria (a pagamento)", "Stirapantaloni", "Soluzioni anallergiche"],
      en: ["Daily housekeeping", "Laundry service (charges apply)", "Ironing service (charges apply)", "Trouser press", "Hypoallergenic options"],
      fr: ["Ménage quotidien", "Blanchisserie (payant)", "Service de repassage (payant)", "Presse-pantalon", "Options hypoallergéniques"]
    }
  },
  {
    id: "security",
    icon: "fa-shield-halved",
    title: { it: "Sicurezza", en: "Safety & security", fr: "Sécurité" },
    items: {
      it: ["Estintori", "Telecamere CCTV nelle aree comuni", "Allarme antifumo", "Cassaforte", "Accesso con chiavi", "Rilevatore di monossido di carbonio"],
      en: ["Fire extinguishers", "CCTV in common areas", "Smoke alarm", "Safe", "Key access", "Carbon monoxide detector"],
      fr: ["Extincteurs", "Vidéosurveillance dans les espaces communs", "Détecteur de fumée", "Coffre-fort", "Accès par clé", "Détecteur de monoxyde de carbone"]
    }
  },
  {
    id: "food",
    icon: "fa-mug-saucer",
    title: { it: "Ristorazione", en: "Food service", fr: "Restauration" },
    items: {
      it: ["Colazione in camera (su richiesta)", "Minibar", "Macchina caffè / bollitore tè", "Frutta (a pagamento)", "Menù per diete particolari (su richiesta)"],
      en: ["In-room breakfast (on request)", "Minibar", "Coffee maker / tea kettle", "Fruit (charges apply)", "Special diet menu (on request)"],
      fr: ["Petit-déjeuner en chambre (sur demande)", "Minibar", "Cafetière / bouilloire", "Fruits (payant)", "Menu pour régimes spéciaux (sur demande)"]
    }
  },
  {
    id: "extras",
    icon: "fa-paw",
    title: { it: "Extra & attività", en: "Extras & activities", fr: "Extras & activités" },
    items: {
      it: ["Animali ammessi su richiesta (nessun supplemento)", "Ciotole per animali domestici", "Happy hour", "Tour a piedi", "Mostre d'arte temporanee", "Escursionismo", "Consegna spesa a domicilio (a pagamento)"],
      en: ["Pets allowed on request (no extra charge)", "Pet bowls", "Happy hour", "Walking tours", "Temporary art exhibitions", "Hiking", "Grocery delivery (charges apply)"],
      fr: ["Animaux acceptés sur demande (sans supplément)", "Gamelles pour animaux", "Happy hour", "Visites à pied", "Expositions d'art temporaires", "Randonnée", "Livraison de courses (payant)"]
    }
  },
  {
    id: "parking",
    icon: "fa-square-parking",
    title: { it: "Parcheggio", en: "Parking", fr: "Parking" },
    items: {
      it: ["Parcheggio pubblico in zona (non prenotabile, € 30/giorno)", "Navetta aeroportuale (a pagamento)"],
      en: ["Public parking nearby (not bookable, €30/day)", "Airport shuttle (charges apply)"],
      fr: ["Parking public à proximité (non réservable, 30 € / jour)", "Navette aéroport (payant)"]
    }
  },
  {
    id: "languages",
    icon: "fa-language",
    title: { it: "Lingue parlate", en: "Languages spoken", fr: "Langues parlées" },
    items: {
      it: ["Italiano", "Inglese", "Francese"],
      en: ["Italian", "English", "French"],
      fr: ["Italien", "Anglais", "Français"]
    }
  }
];

// Accessibility note (separate from grid since it's a caveat, not a perk)
export const ACCESSIBILITY_NOTE = {
  it: "Piani superiori accessibili solo tramite scale.",
  en: "Upper floors accessible only by stairs.",
  fr: "Étages supérieurs accessibles uniquement par les escaliers."
};
